// extracted by mini-css-extract-plugin
export default {"container":"Questions_container__Pil7x","list_item":"Questions_list_item__K4mlK","type":"Questions_type__w6mww"};